import React from 'react';
import { Volume2, Loader2, Square } from 'lucide-react';

const Bars = () => (
  <span className="speak-bars group-hover:hidden" aria-hidden="true">
    <i /><i /><i /><i />
  </span>
);

// phase: 'idle' | 'loading' | 'playing'
export const SpeakButton = ({ phase = 'idle', onClick, variant = 'question', label, stopLabel, testId }) => {
  const active = phase !== 'idle';
  const isOption = variant === 'option';
  const size = isOption ? 'w-9 sm:w-11 self-stretch rounded-lg sm:rounded-2xl' : 'h-9 sm:h-10 min-w-9 sm:min-w-10 px-2.5 rounded-full';
  const tone = active
    ? 'bg-emerald-600 border-emerald-600 text-white shadow-[0_0_0_4px_rgba(16,185,129,0.18)] dark:shadow-[0_0_0_4px_rgba(250,250,250,0.15)]'
    : 'bg-white dark:bg-slate-800/60 border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-200 hover:border-emerald-400 hover:text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-900/30';
  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); onClick(); }}
      className={`group relative flex-shrink-0 flex items-center justify-center gap-1.5 border-2 select-none touch-manipulation
        transition-[background-color,border-color,color,box-shadow,transform] duration-150 active:scale-90
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2 ${size} ${tone}`}
      aria-label={active ? stopLabel : label}
      aria-pressed={active}
      title={active ? stopLabel : label}
      data-testid={testId}
      data-phase={phase}
    >
      {phase === 'loading' && <Loader2 className="w-4 h-4 sm:w-5 sm:h-5 animate-spin" />}
      {phase === 'playing' && (
        <>
          <Bars />
          <Square className="w-3.5 h-3.5 sm:w-4 sm:h-4 fill-current hidden group-hover:block" />
        </>
      )}
      {phase === 'idle' && <Volume2 className="w-4 h-4 sm:w-5 sm:h-5" />}
    </button>
  );
};
